import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDKaOEeZ_9thGv9GSEtW3obdsz2jLDDIa0",
  authDomain: "bba-portal-894c2.firebaseapp.com",
  projectId: "bba-portal-894c2",
  storageBucket: "bba-portal-894c2.firebasestorage.app",
  messagingSenderId: "76541469553",
  appId: "1:76541469553:web:77968955199514b47fccd0",
  measurementId: "G-HRGRXSP03N"
};

const app = initializeApp(firebaseConfig);

// App Check: switches on once REACT_APP_APP_CHECK_SITE_KEY (a reCAPTCHA Enterprise site key
// registered for this app in Firebase console ▸ App Check) is set at build time. Until
// enforcement is turned on in the console, tokens are only measured, never required.
const appCheckSiteKey = process.env.REACT_APP_APP_CHECK_SITE_KEY;
if (appCheckSiteKey && typeof window !== 'undefined') {
  if (process.env.NODE_ENV === 'development') {
    // Prints a debug token to the console; add it under App Check ▸ Manage debug tokens
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

export { auth, db, storage, functions };
export default app;
